import React, { useState } from "react";
import {
  Typography,
  Card,
  Box,
  Grid,
  Menu,
  MenuItem,
  IconButton,
} from "@mui/material";
import { styled } from "@mui/system";
import { MoreVert } from "@mui/icons-material";
import GenericButton from "./GenericButton";
import { useTranslation } from "react-i18next";

const StyledDetailsCard = styled(Card)({
  border: "1px solid #A5A5A5",
  marginBottom: "10px",
  position: "relative",
  paddingTop: "20px",
});

const DetailsCardContent = styled(Box)({
  padding: "10px",
  paddingTop: "0",
});

const MenuIconWrapper = styled(Box)({
  position: "absolute",
  top: 8,
  right: 8,
  zIndex: 1,
});

const CustomProgramCard = ({
  data,
  onEdit,
  onDelete,
  onView,
  id,
  showMenu,
  viewText = "View",
  disabled = false,
}) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuAction = (action) => (event) => {
    event.stopPropagation();
    action();
    handleClose();
  };

  return (
    <StyledDetailsCard>
      {showMenu && (
        <>
          <MenuIconWrapper>
            <IconButton onClick={handleClick} size="small">
              <MoreVert />
            </IconButton>
          </MenuIconWrapper>

          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            onClick={(e) => e.stopPropagation()}
          >
            <MenuItem onClick={handleMenuAction(onEdit)}>{t("Edit")}</MenuItem>
            <MenuItem onClick={handleMenuAction(onDelete)}>
              {t("Delete")}
            </MenuItem>
          </Menu>
        </>
      )}

      <DetailsCardContent>
        <Grid container spacing={0}>
          {data.map(({ label, value, type }, index) => (
            <Grid
              key={`${id}-${index}`}
              display="flex"
              style={{ paddingLeft: "8px" }}
              item
              xs={12}
            >
              <Grid item xs={6}>
                <Typography
                  variant="body1"
                  style={{ color: "#443F3F" }}
                  align="left"
                >
                  {label}:
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  variant="body1"
                  style={{
                    color: "#000000",
                    marginLeft: "8px",
                    wordBreak: "break-word",
                  }}
                  align="left"
                >
                  {type === "component" ? value : value || "N/A"}
                </Typography>
              </Grid>
            </Grid>
          ))}

          {/* Manage Button Section */}
          <Grid item xs={12} style={{ marginTop: "10px" }}>
            <GenericButton
              onClick={(e) => {
                e.stopPropagation();
                if (!disabled) onView();
              }}
              backgroundColor="#E9FFEA"
              fontColor="black"
              borderColor="#4CAF50"
              padding="8px 0"
              fontSize="14px"
              margin="0px"
              disabled={disabled}
              hideIcon
            >
              {viewText}
            </GenericButton>
          </Grid>
        </Grid>
      </DetailsCardContent>
    </StyledDetailsCard>
  );
};

export default CustomProgramCard;
